import React from "react";
import { HexColorPicker } from "react-colorful";

export const SwatchesPicker = ({ color, onChange, presetColors }) => {
  // Use a fallback if "transparent" is passed to the picker.
  const pickerColor = color === "transparent" ? "#FFFFFF" : color;

  return (
    <div className="picker">
      <HexColorPicker color={pickerColor} onChange={onChange} />
      <div className="picker__swatches">
        {presetColors.map((presetColor) => {
          // Check if this preset is the one currently selected.
          const isSelected = presetColor === color;
          return (
            <button
              key={presetColor}
              className="picker__swatch"
              style={{
                position: "relative",
                width: "24px", // fixed size
                height: "24px",
                cursor: "pointer",
                background: presetColor,
                // Highlight if selected: thicker border and different color.
                border: isSelected
                  ? "2px solid var(--brand-primary)"
                  : presetColor === "transparent"
                  ? "1px solid var(--brand-primary)"
                  : "none",
                // Optionally add a box shadow when selected.
                boxShadow: isSelected ? "0 0 4px var(--brand-primary)" : "none",
              }}
              onClick={() => onChange(presetColor)}
            >
              {presetColor === "transparent" && (
                <svg
                  width="100%"
                  height="100%"
                  style={{ position: "absolute", top: 0, left: 0 }}
                >
                  {/* Diagonal line for transparent swatch */}
                  <line
                    x1="0"
                    y1="0"
                    x2="100%"
                    y2="100%"
                    stroke="#ccc"
                    strokeWidth="2"
                  />
                </svg>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};
